import { PageTitle } from '../../../_metronic/layout/core'
import { useEffect, useState } from 'react'
import { TwoItemRow } from './TwoItemInRow'
import { StatisticsWidget5 } from './StatisticsWidget5'
import { StatisticsWidgetVendor } from './StatisticsWidgetVendor'
import { fetchData, findMenuWithParent, getEncodedCookie, getEncryptedRoute, toasterrormsg } from '../../../reusable'
import { getToken } from 'firebase/messaging'
import { messaging } from '../../modules/auth/components/firebase'
import { Tr } from '../../../_metronic/i18n/Tr'
import { ChartsWidget9v2 } from './DashboardChart2'
import moment from 'moment'
import { useMenuContext } from '../contexts/MenuContext'

const DashboardPage = () => {
  let t = Tr()
  const { fullMenu } = useMenuContext()

  const result = findMenuWithParent(fullMenu, "../viewhotelbooking/");
  const accommodationBookingMenuId = result?.menu?.menuId

  const viewUserResult = findMenuWithParent(fullMenu, "../viewuser/");
  const usermenuId = viewUserResult?.menu?.menuId

   const viewVendorResult = findMenuWithParent(fullMenu, "../viewvendor/");
  const vendormenuId = viewVendorResult?.menu?.menuId
  
  const [userCount, setUserCount] = useState('')
  const [vendorCount, setVendorCount] = useState('')
  const [totalRevenue, setTotalRevenue] = useState(0) as any
  const [totalBooking, setTotalBooking] = useState('')
  const [length, setLength] = useState(0) as any
  const [chartData, setChartData] = useState<{ name: string; data: number[] }[]>([])
  const [categories, setCategories] = useState<string[]>([])
  const [data, setData] = useState<any>(null)

  const dashboardDataApiCall = async () => {
    var response: any = await fetchData('admin/dashboarddata', {}, 'GET')

    if (response.status == '200') {
      var data = response.data

      setTotalBooking(data.bookingCount != '' ? data.bookingCount : '')
      setUserCount(data.users != '' ? data.users : '')
      setUserCount(data.users != '' ? data.users : '')
      setVendorCount(data.vendorCount != '' ? data.vendorCount : '')
      setTotalRevenue(data.totalRevenue != '' && data.totalRevenue != null ? data.totalRevenue : '')
      setLength(data.totalRevenue != '' && data.totalRevenue != null ? 1 : '0')
    } else {
      toasterrormsg(response.message)
    }
  }


  useEffect(() => {
    dashboardDataApiCall()
  }, [])

  async function requestPermission() {
    //requesting permission using Notification API
    const permission = await Notification.requestPermission()

    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey:
          'BHWRvoaRc6CQX7cTqGGAmEoqSBi8cefMSaNUZaCSWgOrao6YTcQMr2tzysMicds4dPzaSJP9Zzn4Hu1X02jMJyM',
      })

      saveFcmToken(token)
    } else if (permission === 'denied') {
      //notifications are blocked
    }
  }

  requestPermission()

  const saveFcmToken = async (token: any) => {
    var tmp2 = sessionStorage.getItem('admin')
    // Step 2: Check if the item is not null
    if (tmp2) {
      // Step 3: Parse the JSON string
      var adminData = JSON.parse(tmp2)
      // Step 4: Access the adminId
      var adminId = adminData.adminId
    }
    var param: any = {
      adminId: adminId,
      token: token != '' ? String(token) : '',
    }

    var response: any = await fetchData('admin/savefcmtoken', param)

    if (response.status == '200') {
    } else {
      toasterrormsg(response.message)
    }
  }

  const [popularDestinationList] = useState([{}, {}, {}, {}, {}, {}])

  useEffect(() => {
    document.title = 'Insayr | Dashboard'
  }, [])

  const getData = (data: any) => {
    setData(data)
  }

  const currentYear = moment().year()
  const pastYear = 1968

  const fetchRevenueData = async () => {
    var param: any = {}
    if (data && data.fromYear && data.toYear) {
      param = {
        fromYear: data.fromYear,
        toYear: data.toYear,
      }
    } else {
      param = {
        fromYear: pastYear,
        toYear: currentYear,
      }
    }

    const res = await fetchData('admin/totalrevenuebyyears', param)
    if (res.status === 200) {
      const data = res.data
      setLength(data.length)

      const revenueData = data.map((item: any) => item.total_amount)

      // Flatten categories with repeated years
      const categories = data.map((item: any) => item.year)
      


      setChartData([
        { name: t('Total Revenue'), data: revenueData },
      ])
      setCategories(categories)

      // Calculate total revenue across all years
      const totalServiceFeeAmount = revenueData.reduce((acc: number, value: number) => acc + value, 0)
      setTotalRevenue(totalServiceFeeAmount.toString())
    }
  }
  useEffect(() => {
    fetchRevenueData()
  }, [])

  return (
    <>

      {/* begin::Row */}
      <div className='row g-5 g-xl-8'>
        <div className='col-lg-6 col-xl-6'>
          <div className='row'>
            <div className='col-xl-6 col-lg-6 '>
              <StatisticsWidget5
                className='card-xl-stretch mb-xl-8 height238px'
                icon='Users Group Rounded.svg'
                svgIcon='user'
                color='body-white'
                iconColor='success'
                title={t('Total User')}
                description={userCount}
                titleColor='gray-900 fontsize18px fw-bold'
                descriptionColor='text-dark fontsize48px fontweight700 fw-bold themeBlueColor'
                link={getEncryptedRoute('../viewuser', { menuId: usermenuId })}
              />
            </div>

            <div className='col-xl-6 col-lg-6'>
              <StatisticsWidget5
                className='card-xl-stretch mb-xl-8 height238px'
                icon='Dollar.svg'
                svgIcon='dollar'
                color='body-white'
                iconColor='success'
                title={t('Total Booking')}
                description={totalBooking}
                titleColor='gray-900 fontsize18px fw-bold'
                descriptionColor='text-dark fontsize48px fontweight700 fw-bold themeBlueColor'
                link={getEncryptedRoute('../viewhotelbooking', {
                  menuId: accommodationBookingMenuId,
                })}
              />
            </div>

            <div className=''>
              <StatisticsWidgetVendor
                className='card-xl-stretch mb-xl-8 height238px'
                svgIcon='user'
                icon='Users Group Rounded.svg'
                color='body-white'
                iconColor='success'
                link={getEncryptedRoute('../viewvendor', { menuId: vendormenuId })}
                title={t('Total Vendor')}
                description={vendorCount}
                titleColor='gray-900 fontsize18px fw-bold'
                descriptionColor='text-dark fontsize48px fontweight700 fw-bold themeBlueColor textalignright w-100'
              />
            </div>
          </div>
        </div>

        <div className='col-lg-6 col-xl-6'>
          <ChartsWidget9v2
            className='card-xl-stretch mb-5 mb-xl-8 height440px'
            data={chartData}
            sendData={getData}
            categories={categories}
            totalRevenue={totalRevenue}
            length={length}
          />
        </div>
      </div>
      {/* end::Row */}
      {/* <div className="outer-border">
      <div className="inner-border">
        <div className="table-header">EXAM PAPER TABLE</div>
        <table className="exam-table">
          <tbody>
            <tr>
              <td rowSpan={2}>Maths</td>
              <td rowSpan={2} className="english">English</td>
              <td colSpan={2}>Computer</td>
              <td>C1</td>
              <td>C2</td>
            </tr>
            <tr></tr>
            <tr>
              <td rowSpan={2}>s1</td>
              <td>s2</td>
              <td>PT</td>
              <td colSpan={3} className="bold">Computer Programming</td>
            </tr>
            <tr>
              <td>s3</td>
              <td>HTML</td>
              <td colSpan={3}>JAVA, KOTLIN</td>
            </tr>
            <tr>
              <td className="designing">Designing</td>
              <td>PHP</td>
              <td>XML</td>
              <td colSpan={3}>All Language Viva</td>
            </tr>
            <tr>
              <td>AI</td>
              <td>DBMS</td>
              <td colSpan={4}></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> */}

      {/* begin::Row */}
      <div className='row g-5 g-xl-8'>
        <div className='col-12'>
          <TwoItemRow heading={t('Popular Destination')} data={popularDestinationList} />
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper = () => {
  let t = Tr()

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('Dashboard')}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
